<dgx-product-header
  [shouldHideGlobalSearch]="true"
  [shouldHideGlobalAdd]="true"
  [shouldHideNotifications]="true"
  [context]="PRODUCT_NAME"
  [navLinks]="navLinks"
  [useNgxRouting]="useRouterLinks"
></dgx-product-header>
